import { TicketStatus } from '@/@types/generated'
import format from '@/lib/format'
import { cn } from '@/lib/utils'

export const TicketStatusTextColor: Record<TicketStatus, string> = {
  [TicketStatus.OPEN]: 'text-blue-500',
  [TicketStatus.CLOSED]: 'text-gray-500',
}

export const TicketStatusBackgroundColor: Record<TicketStatus, string> = {
  [TicketStatus.OPEN]: 'bg-blue-500',
  [TicketStatus.CLOSED]: 'bg-gray-500',
}

export function TicketStatusBadge({ status }: { status: TicketStatus }) {
  return (
    <div className="flex items-center gap-0.5 capitalize">
      <span
        className={cn(
          'relative h-4 text-4xl leading-3',
          TicketStatusTextColor[status]
        )}
      >
        &bull;
      </span>
      <span>{format.Enum(TicketStatus, status)}</span>
    </div>
  )
}
